import Swiper, {HashNavigation, Keyboard, Mousewheel, Navigation} from 'swiper';
import Observer from '../../common/scripts/observer';
import {throttle} from 'throttle-debounce';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class FullScreenScroll {
    constructor() {
        this.slider = {};

        /**
         * Враппер страницы
         * @type {HTMLElement}
         */
        this.page = document.querySelector('.j-home-slider');
        this.wrapper = this.page.querySelector('.j-home-slider-wrapper');
        this.footer = document.querySelector('footer');
        this.speed = 1000;
        this.activeClass = 'is-active';
    }

    init() {
        if (Utils.getWindowWidth() > 1279.95) {
            // Инициализация полноэкранного скролла на больших экранах
            this._initSwiper();
        }

        window.addEventListener('resize', () => {
            if (Utils.getWindowWidth() > 1279.95 && !this.slider.initialized) {
                // Инициализация полноэкранного скролла на больших экранах
                this._initSwiper();
            } else if (Utils.getWindowWidth() < 1279.95 && this.slider.initialized) {
                this._destroySwiper();
            }
        });

        observer.subscribe('homeSlideTo', () => {
            if (this.slider) {
                this.slider.allowSlidePrev = true;
                this.slider.allowSlideNext = true;
            }
        });
    }

    _initSwiper() {
        const nextBlockButtons = Array.from(document.querySelectorAll('.j-next-block'));

        this.wrapper.classList.add('swiper-wrapper');

        if (this.page) {
            const options = {
                modules                       : [HashNavigation, Navigation, Mousewheel, Keyboard],
                direction                     : 'vertical',
                effect                        : 'fade',
                allowTouchMove                : false,
                speed                         : this.speed,
                threshold                     : 1200,
                simulateTouch                 : false,
                longSwipes                    : false,
                preventInteractionOnTransition: true,
                mousewheel                    : true,
                // hashNavigation                : true,
                hashNavigation                : {
                    watchState: true
                },
                keyboard: {
                    enabled       : true,
                    onlyInViewport: false
                },
                on: {
                    init: (swiper) => {
                        // Устанавливаем цвет шапки
                        this._setHeaderColor(swiper.slides[swiper.activeIndex].dataset.header);
                    }
                }
            };

            this.slider = new Swiper(this.page, options);
            this.slider.init();

            const slides = Array.from(this.slider.slides);

            slides.forEach((slide) => {
                if (slide.id) {
                    slide.dataset.id = slide.id;
                    slide.removeAttribute('id');
                }
            });

            this._checkDevice();

            this._onChange();

            this.slider.on('reachEnd', () => {
                setTimeout(() => {
                    this._reachEnd();
                }, this.speed / 2);
            });
        }

        if (nextBlockButtons.length) {
            this._nextBlock(nextBlockButtons);
        }
    }

    _destroySwiper() {
        const slides = Array.from(this.slider.slides);
        const allActive = Array.from(document.querySelectorAll('.swiper-slide.is-active'));

        slides.forEach((item) => {
            const slideId = item.dataset.id;

            if (slideId) {
                item.id = slideId;
                item.removeAttribute('data-id');
            }
        });
        this.slider.destroy(true, true);
        this.wrapper.classList.remove('swiper-wrapper');

        if (allActive.length) {
            allActive.forEach((item) => {
                item.classList.remove('is-active');
            });
        }
    }

    /**
     * Проверяем устройство скролла пользователя - мышь или тачпад
     */
    _checkDevice() {
        const scrollListener = (event) => {
            let isTrackpad = false;

            const setDevice = () => {
                isTrackpad = true;
                this.page.dataset.devicetype = isTrackpad;
                document.removeEventListener('mousewheel', scrollListener);
                document.removeEventListener('DOMMouseScroll', scrollListener, false);
            };

            if (event.wheelDeltaY) {
                if (event.wheelDeltaY === (event.deltaY * -3)) {
                    setDevice();
                }
            } else if (event.deltaMode === 0) {
                setDevice();
            }
        };

        if (!this.page.dataset.devicetype) {
            document.addEventListener('mousewheel', scrollListener, false);
            document.addEventListener('DOMMouseScroll', scrollListener, false);
        }
    }

    _onChange() {
        this.slider.on('slideChangeTransitionEnd', (swiper) => {
            // Получаем активный слайд
            const activeSlide = swiper.slides[swiper.activeIndex];
            // Получаем цвет шапки
            const headerColor = activeSlide.dataset.header;
            // Получаем значение доп экрана в рамках текущего слайда
            const additionalElement = activeSlide.dataset.additional;
            // Получаем аккорден у текущего слайда если он есть
            const accordionOnSlide = activeSlide.querySelector('.j-questions-accordion');

            this.slider.allowSlideNext = false;
            this.slider.allowSlidePrev = false;

            // Устанавливаем цвет шапки
            this._setHeaderColor(headerColor);

            // Устанавливаем фокус на аккордеон если он есть
            if (accordionOnSlide) {
                this._setAccordionActive(accordionOnSlide);
            }

            // Проверяем не вылез ли где футер
            if (swiper.activeIndex !== swiper.slides.length - 1) {
                this.footer.style.zIndex = '-1';
            }

            // Отображаем доп элемент при скролле если он имеется
            if (additionalElement) {
                this._showAdditional(activeSlide);
            } else {
                this.slider.allowSlidePrev = true;
                this.slider.allowSlideNext = true;
            }
        });
    }

    /**
     *
     * @param {string} color - цвет шапки активного слайда
     */
    _setHeaderColor(color = '') {
        const header = document.querySelector('.j-header');
        const nowColor = header.dataset.activeColor;

        if (!color) {
            if (nowColor !== '') {
                header.classList.remove(`header_theme_${nowColor}`);
                header.dataset.activeColor = '';
            }

            return;
        }

        if (nowColor !== '') {
            header.classList.remove(`header_theme_${nowColor}`);
            header.dataset.activeColor = color;
        }

        header.classList.add(`header_theme_${color}`);
        header.dataset.activeColor = color;
    }

    /**
     *
     * @param {object} slide - текущий слайд со скрытым элементом
     */
    /* eslint-disable */
    _showAdditional(slide) {
        const setState = (state) => {
            slide.classList[state](this.activeClass);
        };

        // Движемся вверх
        const moveUp = (keyboard = false) => {
            if (!slide.classList.contains(this.activeClass)) {
                this.slider.allowSlidePrev = true;
                this.slider.update();
                if (keyboard) {
                    this.slider.slidePrev();
                }
            } else {
                setState('remove');
            }
        };

        // Движемся вниз
        const moveDown = (keyboard = false) => {
            if (!slide.classList.contains(this.activeClass)) {
                setState('add');
            } else {
                this.slider.allowSlideNext = true;
                if (keyboard) {
                    this.slider.slideNext();
                }
            }
        };

        const listener = (detail) => {
            // Определяем - есть направление скролла
            const direction = detail.deltaY > 0 ? 'down' : 'up';

            // Выполняем функцию в зависимости от направления движения
            if (direction === 'down') {
                moveDown();
            } else if (direction === 'up') {
                moveUp();
            }

            // Удаляем слушателя события
            this.slider.on('slideChange', () => {
                document.removeEventListener('wheel', this.throttleListener);
            });
        };

        // Обрабатываем события нажатия кнопок клавиатуры
        const keyboardListener = (event) => {
            if (event.code === 'ArrowUp' || event.code === 'PageUp') {
                moveUp(true);
            } else if (event.code === 'ArrowDown' || event.code === 'PageDown') {
                moveDown(true);
            }

            this.slider.on('slideChange', () => {
                document.removeEventListener('keyup', keyboardListener);
            });
        }

        // Показывает доп блок по нажатию на кнопку со стрелкой
        const scrollBtn = slide.querySelector('.j-additional-scroll');

        if (scrollBtn) {
            scrollBtn.addEventListener('click', () => {
                setState('add');
            });
        }

        this.throttleListener = throttle(600, listener);

        document.addEventListener('wheel', this.throttleListener);
        document.addEventListener('keyup', keyboardListener);
    }

    /**
     * Срабатывает при скролле до последнего экрана
     */
    _reachEnd() {
        const slides = this.slider.slides;
        const lastSlide = slides[slides.length - 1];
        // Флаг было ли действия скролла после переход на текущий слайд
        let scrolled = false;
        // Количество "скроллов" после перехода
        let scrollCounter = 0;

        const showFooter = (details) => {
            if (this.slider.realIndex !== slides.length - 1) {
                document.removeEventListener('wheel', showFooter);
                document.removeEventListener('keyup', showFooter);
            }

            if ((!this.slider.enabled && Number(this.footer.style.zIndex) !== 1) || this.slider.activeIndex !== slides.length - 1) {
                return;
            }

            // Прячем футер если он внезапно вылез не внизу сайта
            if (this.slider.activeIndex !== slides.length - 1 && this.footer.style.zIndex === '1') {
                this.footer.style.zIndex = '-1';
            }
            // Определяем - есть направление скролла
            let direction = '';

            if (details.type === 'wheel' || details.type === 'mousewheel') {
                direction = details.deltaY > 0 ? 'down' : 'up';
            } else if (details.type === 'keyup') {
                if (details.code === 'ArrowUp' || details.code === 'PageUp') {
                    direction = 'up';
                } else if (details.code === 'ArrowDown' || details.code === 'PageDown') {
                    direction = 'down';
                }
            }
            // Определяем высоту футера
            const footerHeight = this.footer.offsetHeight;
            // Количество нажатий (скроллов) до показа футера
            const numForShow = this.page.dataset.devicetype ? 14 : 1;

            // Прячем футер (force - указывает на то что прячем принудительно или нет)
            const hideFooter = (force = false) => {
                // Какой листенер отключать
                const whatListener = details.type === 'mousewheel' ? 'wheel' : 'keyup';

                // прячем футер
                if (!force) {
                    lastSlide.style.transform = 'translateY(0)';
                }

                this.footer.style.zIndex = '-1';
                this._setHeaderColor();
                document.removeEventListener(whatListener, showFooter);

                // Включаем слайдер
                setTimeout(() => {
                    this.slider.enable();
                }, 500);

                // Сбрасываем значение и флаг скролла
                scrolled = false;
                scrollCounter = 0;
            }

            scrolled = scrollCounter > numForShow;

            if (direction === 'down' && scrolled) {
                lastSlide.style.transform = `translateY(-${footerHeight}px)`;

                this.slider.disable();

                setTimeout(() => {
                    this._setHeaderColor('blue');
                    this.footer.style.zIndex = '1';
                }, 500);
            } else if (direction === 'up' && scrolled) {
                hideFooter();
            } else if (direction === 'down') {
                // scrolled = false;
                scrollCounter++;
            } else if (direction === 'up' && !scrolled && Number(this.footer.style.zIndex) === 1) {
                hideFooter(true);
            }
        };

        document.addEventListener('wheel', showFooter);
        document.addEventListener('keyup', showFooter);

        observer.subscribe('scrollToTop', () => {
            if (!this.slider.enabled) {
                this.slider.enable();
            }

            this.slider.slideTo(0, 500);
            lastSlide.style.transform = 'translateY(0)';
            this.footer.style.zIndex = '-1';
            document.removeEventListener('wheel', showFooter);
            document.removeEventListener('keyup', showFooter);
        });
    }
    /* eslint-enable */

    /**
     *
     * @param {array} buttons - массив всех кнопок на странице для переключения на блок ниже
     */
    _nextBlock(buttons) {
        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                this.slider.slideNext();
            });
        });
    }

    _setAccordionActive(accordion) {
        accordion.onmouseenter = () => {
            this.slider.disable();
        };

        accordion.onmouseleave = () => {
            this.slider.enable();
        };
    }
}

export default FullScreenScroll;
